import Layout from "../../components/layout";
import {GetStaticProps} from "next";
import Link from "../../components/Link";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import nextI18NextConfig from "../../next-i18next.config";
import '../../styles/scss/_events-page.module.scss';

export default function ObservabilityMeetupBangalore({ props }) {
    const { t } = useTranslation('common');
    const pageData = t('resources.events.pages.observabilityMeetupBangalore', { returnObjects: true, defaultValue: {} }) as any;
    
    const heroData = pageData?.hero || {};
    const contentData = pageData?.content || {};
    const speakersSectionData = contentData?.speakersSection || {};
    
    // Helper function to safely convert to string (handles objects)
    const safeString = (value: any): string => {
        if (value === null || value === undefined) return '';
        if (typeof value === 'string') return value;
        if (typeof value === 'object') {
            // If it's an object, try to extract a meaningful string
            if (value.text) return String(value.text);
            if (value.value) return String(value.value);
            if (value.label) return String(value.label);
            // If no recognizable property, return empty string instead of [object Object]
            return '';
        }
        return String(value);
    };
    
    return(
        <>
            <Layout isHomePage={false} pageTitle={String(pageData?.pageTitle ?? '')}
                    ogImage={String(pageData?.ogImage ?? '')}
                    uri={String(pageData?.uri ?? '')}
                    metaTitle={String(pageData?.metaTitle ?? '')}
                    metaDesc={String(pageData?.metaDesc ?? '')}
                    metaRobotsNoindex={String(pageData?.metaRobotsNoindex ?? '')}
                    metaRobotsNofollow={String(pageData?.metaRobotsNofollow ?? '')}>

                <div className={'global-wrapper'} >
                    <div className={"event-page dine-with-devops"}>
                        <section className={'hero-section'}>
                            <div className={'container'}>
                                <div className={'d-flex'}>
                                    <div className={'left-block'}>
                                        <Link href={String(heroData?.backLinkUrl ?? '/events/')} className={"back-to-blog"}>{String(heroData?.backLink ?? '')}</Link>
                                        {heroData?.logo && (
                                            <div className={'d-flex aws-mw'}>
                                                <img src={safeString(heroData.logo?.src)} alt={safeString(heroData.logo?.alt)} className={'aws-logo'} width={"100%"} height={"100%"}/>
                                            </div>
                                        )}
                                        <div className={'inner-hero'}>
                                            <h1>
                                                {safeString(heroData?.titlePrefix ?? '')}
                                                <span>{safeString(heroData?.titleHighlight ?? '')}</span>
                                                {safeString(heroData?.titleMiddle ?? '')}
                                                <span>{safeString(heroData?.titleHighlight2 ?? '')}</span>
                                                {safeString(heroData?.titleSuffix ?? '')}
                                            </h1>
                                            {heroData?.date && <p><b>Date: </b>{safeString(heroData.date)}</p>}
                                            {heroData?.time && <p><b>Time: </b>{safeString(heroData.time)}</p>}
                                            {heroData?.venue && <p><b>Venue: </b>{safeString(heroData.venue)}</p>}
                                        </div>
                                    </div>
                                    <div className={'right-block'}>
                                        <img
                                            src={String(heroData?.image?.src ?? '')} alt={String(heroData?.image?.alt ?? '')} width={"100%"} height={"100%"}/>
                                    </div>
                                </div>

                            </div>
                        </section>
                        <section className={'content-section'}>
                            <div className={'container'}>
                                    <div className={'left-block sm-width'}>
                                        <p>{String(contentData?.description ?? '')}</p>
                                        
                                        {contentData?.hasSpeakers && speakersSectionData && (
                                            <>
                                                <h4>{String(speakersSectionData?.title ?? '')}</h4>
                                                {Array.isArray(speakersSectionData?.speakers) && speakersSectionData.speakers.map((speaker: any, index: number) => (
                                                    <p key={index}>
                                                        <b>{String(speaker?.name ?? '')},</b> {speaker?.role && (
                                                            <span dangerouslySetInnerHTML={{__html: String(speaker.role).replace(/<Link/g, '<a').replace(/<\/Link>/g, '</a>')}}></span>
                                                        )}: {String(speaker?.topic ?? '')}
                                                    </p>
                                                ))}
                                                {speakersSectionData?.registerLink && (
                                                    <p>
                                                        {String(speakersSectionData?.registerText ?? '')} 
                                                        <Link href={String(speakersSectionData.registerLink)} target={"_blank"}>{String(speakersSectionData.registerLink)}</Link>
                                                    </p>
                                                )}
                                                {speakersSectionData?.closingText && (
                                                    <p>{String(speakersSectionData.closingText)}</p>
                                                )}
                                            </>
                                        )}
                                    </div>

                                    {Array.isArray(speakersSectionData?.eventImages) && speakersSectionData.eventImages.length > 0 && (
                                        <div className={"image-flex-event"}>
                                            {speakersSectionData.eventImages.map((image: any, index: number) => (
                                                <img key={index} src={String(image?.src ?? '')} alt={String(image?.alt ?? '')} width={100} height={100}/>
                                            ))}
                                        </div>
                                    )}

                            </div>
                        </section>
                    </div>
                </div>

            </Layout>
        </>
    )
}

export const getStaticProps: GetStaticProps = async (ctx) => {
  const translations = await serverSideTranslations(
    ctx?.locale ?? "en",
    ["common", "header", "footer"],
    nextI18NextConfig,
  );
    return {
        props: {
            ...translations,
            pageTitle: "Observability Meetup in Bengaluru: Middleware x Nokia",
            description:"Meet Middleware and Nokia on Aug 31, 2024, Bengaluru to explore observability and AI-driven monitoring with industry experts.",
            ogImage: "/images/events/observability-meetup-banglore.png",
            uri:"/events/observability-meetup-bangalore/",
            metaTitle:"Observability Meetup in Bengaluru: Middleware x Nokia",
            metaDesc:"Meet Middleware and Nokia on Aug 31, 2024, Bengaluru to explore observability and AI-driven monitoring with industry experts.",
            metaRobotsNoindex:"index",
            metaRobotsNofollow:"follow",
        },
    }
}

